export default __webpack_public_path__ + "static/media/phone.icon.ace115f4.svg";